import { createInjectionKey as o } from "./highrise529.mjs";
const t = o("n-avatar-group");
export {
  t as avatarGroupInjectionKey
};
